import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { catchError, Observable } from 'rxjs';
import { BasedataService } from '../../shared/basedata.service';
import { CreateBimModelVersionDto } from './bim-model-version.dto';
import { BimModelVersion } from './bim-model-version.interface';
import { BpConfigService } from '../../config/bp-config.service';


@Injectable({providedIn: 'root'})
export class BimModelVersionApiService extends BasedataService {

  endpoint: string;

  constructor(private http: HttpClient, configService: BpConfigService) {
    super(configService);
    this.endpoint = super.getFullUrl('bim-models');
  }

  createBimModelVersion(bimModelId: string, bimModelVersion: CreateBimModelVersionDto): Observable<BimModelVersion> {
    return this.http
      .post<BimModelVersion>(this.endpoint + '/' + bimModelId + '/versions' , bimModelVersion);
  }

  updateBimModelVersion(id: string, dto: any): Observable<BimModelVersion> {
    return this.http
        .patch<BimModelVersion>(this.endpoint + "/versions/" + id, dto);
  }

  delete(item: BimModelVersion): Observable<BimModelVersion> {
    return this.http
          .delete<BimModelVersion>(this.endpoint + "/versions/" + item.id)
          .pipe(
            catchError(e => {
              throw new HttpErrorResponse(e)
            })
          )

  }


}
